const ProductCard = (props) => {
  return (
    <span className="d-flex col-12 col-lg-6 p-2">
      <a
        href={props.link}
        target="_blank"
        rel="noreferrer"
        className="productCard row justify-content-center py-4"
      >
        <img
          className="productImage mb-3"
          src={props.img}
          alt="Best-Selling NMV-wise"
        />
        <div>
          <span className="RankTitle">Rank</span>
          <span className="RankNumber">{props.rank}</span>
        </div>
        <div className="col-12 mt-3 mb-2 dk-regular">{props.title}</div>
        <div className="dk-link dk-bold">{"Order Now >"}</div>
      </a>
    </span>
  );
};

export default ProductCard;
